module.exports = __webpack_public_path__ + "static/media/chevron.1f868804.svg";